export const SET_PAGE_TITLE = "page.setTitle";

export const setPageTitle = (title) => {
    return {
        type: SET_PAGE_TITLE,
        payload: title
    };
};